import { render } from "./discount-agent-badge.vue?vue&type=template&id=27244ac9&scoped=true&ts=true"
import script from "./discount-agent-badge.vue?vue&type=script&lang=ts"
export * from "./discount-agent-badge.vue?vue&type=script&lang=ts"

import "./discount-agent-badge.vue?vue&type=style&index=0&id=27244ac9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27244ac9"]])

export default __exports__